"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasObject = exports.hasMap = exports.isRecord = exports.isAny = exports.isNumber = exports.isString = exports.isBoolean = exports.hasArray = exports.hasChoice = exports.hasAny = exports.hasString = exports.hasNumber = exports.hasBoolean = exports.check = void 0;
const AnyCondition_1 = require("./conditions/AnyCondition");
const AnyPropertyCondition_1 = require("./conditions/AnyPropertyCondition");
const ArrayCondition_1 = require("./conditions/ArrayCondition");
const ChoiceCondition_1 = require("./conditions/ChoiceCondition");
const MapCondition_1 = require("./conditions/MapCondition");
const NumberCondition_1 = require("./conditions/NumberCondition");
const ObjectCondition_1 = require("./conditions/ObjectCondition");
const PrimitiveCondition_1 = require("./conditions/PrimitiveCondition");
const PrimitivePropertyCondition_1 = require("./conditions/PrimitivePropertyCondition");
const RecordCondition_1 = require("./conditions/RecordCondition");
const RootCondition_1 = require("./conditions/RootCondition");
const StringCondition_1 = require("./conditions/StringCondition");
function check(value, ...conditions) {
    return new RootCondition_1.RootCondition(value, conditions);
}
exports.check = check;
function hasBoolean(property) {
    return new PrimitivePropertyCondition_1.PrimitivePropertyCondition(property, "boolean");
}
exports.hasBoolean = hasBoolean;
function hasNumber(property) {
    return new NumberCondition_1.NumberCondition(property);
}
exports.hasNumber = hasNumber;
function hasString(property) {
    return new StringCondition_1.StringCondition(property);
}
exports.hasString = hasString;
function hasAny(property) {
    return new AnyPropertyCondition_1.AnyPropertyCondition(property);
}
exports.hasAny = hasAny;
function hasChoice(property, choices) {
    return new ChoiceCondition_1.ChoiceCondition(property, choices);
}
exports.hasChoice = hasChoice;
function hasArray(property, itemCondition) {
    return new ArrayCondition_1.ArrayCondition(property, itemCondition);
}
exports.hasArray = hasArray;
function isBoolean() {
    return new PrimitiveCondition_1.PrimitiveCondition("boolean");
}
exports.isBoolean = isBoolean;
function isString() {
    return new PrimitiveCondition_1.PrimitiveCondition("string");
}
exports.isString = isString;
function isNumber() {
    return new PrimitiveCondition_1.PrimitiveCondition("number");
}
exports.isNumber = isNumber;
function isAny() {
    return new AnyCondition_1.AnyCondition();
}
exports.isAny = isAny;
function isRecord(...itemConditions) {
    return new RecordCondition_1.RecordCondition(itemConditions);
}
exports.isRecord = isRecord;
function hasMap(property, itemCondition) {
    return new MapCondition_1.MapCondition(property, itemCondition);
}
exports.hasMap = hasMap;
function hasObject(property, ...itemConditions) {
    return new ObjectCondition_1.ObjectCondition(property, itemConditions);
}
exports.hasObject = hasObject;
//# sourceMappingURL=Check.js.map